import React from "react";
import MiniDrawer from "./navbar"; // o donde tengas el sidebar

export const RouterLayout = () => {
  return <MiniDrawer />;
};